import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFab,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenuButton,
  IonNote,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import { chevronUpOutline, downloadOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { sendFile } from "../../../store/supervisorRequiredDocuments/actions/sendFile";
import { findHojaDeCargo } from "../../../store/supervisorRequiredDocuments/actions/findHojaDeCargo";
import { selectFindHojaDeCargo } from "../../../store/supervisorRequiredDocuments/selectors/selectFindHojaDeCargo";
import { SendForSignBtn } from "./SendForSignBtn";
import { statusDetail } from "../../../utils/statusDetail";
import { findUserRoles } from "../../../store/supervisorHome/actions/findUserRoles";
import { usePhotoGallery } from "./cameraAccess";
import { sendPhoto } from "../../../store/supervisorRequiredDocuments/actions/sendPhoto";
import api from "../../../utils/api";

export const HojaDeCargoInterior: React.FC = () => {
  const [presentToast, hideToast] = useIonToast();

  const { photos, takePhoto, photoInfo } = usePhotoGallery();

  const [fileHolder, setFileHolder] = useState<any>([]);

  const { id }: { id: any } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(findHojaDeCargo(id));
    dispatch(findUserRoles());
  }, []);

  const handleSendNotificationTest = async (fileHolder: any) => {
    try {
      await hideToast();
      presentToast({
        message: `Cargando Archivo...`,
        color: "primary",
      });
      if (fileHolder.length > 0) {
        const { payload: notificationCreated }: any = await dispatch(sendFile([fileHolder, id]));
        if (!notificationCreated) {
          throw new Error("No se pudo cargar el archivo");
        }
      }

      await hideToast();
      presentToast({
        message: `Se cargo correctamente el archivo`,
        color: "success",
        duration: 8000,
      });
      dispatch(findHojaDeCargo(id));
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema al enviar el archivo",
        color: "danger",
        duration: 8000,
      });
    }
  };

  useEffect(() => {
    if (photos.length > 0) {
      dispatch(sendPhoto(photos));
    }
  }, [photos]);

  useEffect(() => {
    if (fileHolder.length > 0) {
      handleSendNotificationTest(fileHolder);
    }
  }, [fileHolder]);

  const hojasDeCargo = useSelector(selectFindHojaDeCargo);

  const date = hojasDeCargo ? new Date(hojasDeCargo[0]?.createdAt) : new Date();
  const date0 = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();

  const statusDigitalSignature: any = hojasDeCargo
    ? hojasDeCargo[0]?.hojaCargo.statusDigitalSignature
    : null;

  const statusIcon = statusDetail.find(({ code }) => statusDigitalSignature === code);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <Helmet>
          <title>Mi GuardService - Documentos</title>
        </Helmet>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="light" />
          </IonButtons>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/documentos" />
          </IonButtons>
          <IonButtons slot="end">
            <IonButton
              href={`${api.hojasDeCargoURL}hojacargo/getPdf?id=${id}`}
              target="_BLANK"
              download="true"
            >
              <IonIcon icon={downloadOutline} slot="start" />
              <IonText>PDF</IonText>
            </IonButton>
          </IonButtons>
          <IonTitle>
            <h4 className="ion-text-wrap">HC {id}</h4>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonFab
          vertical="bottom"
          horizontal="end"
          slot="fixed"
          style={{ bottom: "6%", right: "3%", display: "flex" }}
        >
          <IonButton style={{ fontWeight: 600 }} color="secondary" size="large">
            <label
              htmlFor="docButton"
              style={{
                cursor: "pointer",
                display: "flex",
                height: "60px",
                justifyContent: "center",
                alignItems: "center",
              }}
              color="secondary"
            >
              <IonIcon icon={chevronUpOutline} slot="start" />
              <IonLabel>SUBIR</IonLabel>
            </label>
          </IonButton>
          <input
            type="file"
            id="docButton"
            name="nombre documento"
            style={{ display: "none" }}
            onChange={(event) => setFileHolder(event.target.files)}
            accept="image/jpeg,image/png"
            required
          />
          <SendForSignBtn hcId={id} />
        </IonFab>
        <IonGrid>
          <IonItem lines="none" color="transparent">
            <IonLabel>
              <h2 className="ion-text-wrap">
                <IonLabel style={{ fontWeight: 600 }}>Creada por: </IonLabel>
                {hojasDeCargo ? hojasDeCargo[0]?.hojaCargo.nombreCompleto : ""}
              </h2>
              <br />
              <h2>
                <IonLabel style={{ fontWeight: 600 }}>Fecha de creación: </IonLabel>
                {date0}
              </h2>
            </IonLabel>
            <IonNote slot="end">
              <IonBadge color={statusIcon?.color}>
                <IonIcon icon={statusIcon?.icon}></IonIcon>
                <IonText class="ion-margin-start">
                  {hojasDeCargo ? statusDigitalSignature : "sin datos"}
                </IonText>
              </IonBadge>
            </IonNote>
          </IonItem>
          <IonRow>
            <IonCol size="12">
              <IonList>
                <IonItem lines="none" style={{ width: "100%" }}>
                  <IonLabel slot="start" style={{ fontWeight: 600 }}>
                    Insumo:
                  </IonLabel>
                  <IonLabel
                    slot="end"
                    class="ion-text-center"
                    style={{ fontWeight: 600, margin: "auto" }}
                  >
                    Cantidad:
                  </IonLabel>
                </IonItem>
                {hojasDeCargo
                  ? hojasDeCargo.map((hojaDeCargo, index) => (
                      <IonItem key={index} lines="none">
                        <IonLabel slot="start">
                          <IonText className="ion-text-wrap">{hojaDeCargo.productName}</IonText>
                        </IonLabel>
                        <IonLabel slot="end" class="ion-text-center" style={{ margin: "auto" }}>
                          {hojaDeCargo.quantity}
                        </IonLabel>
                      </IonItem>
                    ))
                  : null}
              </IonList>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
